import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    state() {
        return {
            hasError: false,
            formHasError: false,
            dialogOpened: false,
            warningPanelText: "",
            pageIsLoading: false,
            pendingRequestCount: 0,
            isExplainableError: false,
            explainInProgress: false
        }
    },
    getters,
    actions,
    mutations
}